import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation
} from "@angular/core";
import {ApiService} from "../../../../../../../../common/services/api.service";
import {Modal, ModalService} from "../../../../../../../services/modal.service";
import {ToastService} from "../../../../../../../../common/services/toast.service";
import {StorageService} from "../../../../../../../../common/services/storage.service";
import {OrderWizardItemSalesComponent} from "../../../index";
import {OrderWizardItemsComponent} from "../items";
import {PusherService} from "../../../../../../../../common/services/pusher.service";
import {SpinnerService} from "../../../../../../../../common/services/spinner.service";
import {PartnerService} from "../../../../../../../../common/services/partner.service";
import {PartnerPartMasterService} from "../../../../../services/part-master.service";
import {Wizard} from "../../../../../../../../common/interfaces/wizard.interface";
import {Api3Service} from "../../../../../../../../common/services/api3.service";

@Component({
    selector: "section-order-wizard-items-sales",
    templateUrl: "../items.component.html",
    styleUrls: [
        "../items.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class OrderWizardItemsSalesComponent extends OrderWizardItemsComponent implements OnChanges {

    public constructor(
        protected apiService: ApiService,
        protected api3Service: Api3Service,
        protected modalService: ModalService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected toastService: ToastService,
        protected storageService: StorageService,
        protected pusherService: PusherService,
        protected partMasterService: PartnerPartMasterService,
        protected spinnerService: SpinnerService
    ) {
        super(apiService, api3Service, modalService, changeDetectorRef, toastService,
            storageService, pusherService, partMasterService, spinnerService);
    }


    protected getDefaultOutboundHubId(): number {
        const add_order_storage = this.storageService.get("add_order");
        if (add_order_storage && add_order_storage?.hub_id) {
            return add_order_storage?.hub_id;
        }
        if (this.address.outbound_inventory_conversions.length) {
            return this.address.outbound_inventory_conversions[0].id;
        }
        return super.getDefaultHubId();
    }

    protected setup(data: Wizard.IData): void {
        super.setup(data);

        this.prepareOutboundTable();
    }

    /**
     * Add new item
     * @returns {void}
     */
    public async addItem(type: string = "outbound"): Promise<any> {
        const response: Modal.IResponse = await this.modalService.open(OrderWizardItemSalesComponent, {
            partmasters: this.partmasters,
            details: this.details,
            order_id: this.data.order_id,
            serviceLevel: this.serviceLevel,
            state: this.state,
            modalWidth: "95%",
            modalHeight: "90%",
            default_outbound_hub_id: this.getDefaultOutboundHubId(),
            disable_hub_select: PartnerService.partner.properties["lock_hub_in_order"]
        });
        if (response && response.value) {
            this._skipAllocations = false;
            this.outboundTableRef.reload(this.getUrl("outbound"));
            this.changeDetectorRef.markForCheck();
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
    }
}
